import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

export function getName(){
  return 'archive/movie'
}

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var columns = [
    {
      id: 'de',
      value: item.de,
      type: o.type.text,
    },
    {
      id: 'en',
      value: item.en,
      type: o.type.text,
    },
    {
      id: 'fr',
      value: item.fr,
      type: o.type.text,
    },
    {
      id: 'ru',
      value: item.ru,
      type: o.type.text,
    },
    {
      id: 'project',
      value: item.project,
      type: o.type.text,
    },
    {
      id: 'duration',
      value: item.duration,
      type: o.type.text,
    },
    {
      id: 'sortId',
      value: item.sortId,
      type: o.type.number,
    },
    {
      id: 'public',
      value: item.public,
      type: o.type.toggle,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      table: {
        width: 300,
        multiline: true,
      },
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.movies,

      function(item){

        var model = o.model.aMovies
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            o.edit.set(item,model)
          }

        return {

          columns: columns,
          click: click,

        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  var fields = [
    {
      id: 'project',
      value: item.project,
      type: 'text',
      edit: true,
    },
    {
      id: 'de',
      value: item.de,
      type: 'text',
      edit: true,
    },
    {
      id: 'en',
      value: item.en,
      type: 'text',
      edit: true,
    },
    {
      id: 'fr',
      value: item.fr,
      type: 'text',
      edit: true,
    },
    {
      id: 'ru',
      value: item.ru,
      type: 'text',
      edit: true,
    },
    {
      id: 'duration',
      value: item.duration,
      type: 'text',
      edit: true,
    },
    {
      id: 'sortId',
      value: item.sortId,
      type: 'number',
      edit: true,
    },
    {
      id: 'public',
      value: item.public,
      type: 'toggle',
      edit: true,
      init: item.public,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      edit: true,
      optional: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.movies
  var collection = 'movies'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var data = o.data.users
  var collection = 'movies'

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.movies
  var collection = 'movies'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aMovies/aMovies.js